import { Pipe, PipeTransform } from '@angular/core';
import { formatDecimal } from 'angular/utils/number-helper.util';
import Decimal from 'decimal.js';

@Pipe({ name: 'pkpDecimal' })
export class DecimalPipe implements PipeTransform {
    transform(value: Decimal | string, ...args: any[]): any {
        if (!value) return null;

        if (Decimal.isDecimal(value)) {
            return formatDecimal(value as Decimal);
        } else {
            try {
                return formatDecimal(new Decimal(value));
            } catch (e) {
                return '';
            }
        }
    }
}
